export enum ActionTypes {
  CreateTemporaryAccount = 'Création de comptes temporaire',
  ResetPassword = 'Réinitialisation de mots de passe',
  RecoverUsername = 'Demande de récupération du nom d\'utilisatteur',
  RecoverPassword = 'Demande d\'activation ou réinitialisation du mot de passe',
  ChangePassword = 'Changement de mot de passe',
  ChangeWifiStatus = 'Modification de l\'accès au Wifi',
  ModifiedRole = 'Modification des rôles',
  ModifiedService = 'Modification des services',
  ModifiedEvents = 'Modification de l\'historique',
  DeleteTemporaryAccount = 'Suppression de comptes temporaire',
  ModifyTemporaryAccount = 'Mise à jour de comptes temporaire',
  DisableTemporaryAccount = 'Désactivation de comptes temporaire',
  EnableTemporaryAccount = 'Activation de comptes temporaire',
  ExtendDateTemporaryAccount = 'Extension de la validité d\'un compte temporaire',
  StartMireoMission = 'Démarrer une mission de remplacement',
  EndMireoMission = 'Terminer une mission de remplacament',
  ExtendDateMireoAccount = 'Extension de la validité d\'un compte remplaçant',
  ChangeEmail = 'Changement d\'email',
  CreateRole = 'Création de rôles',
  ModifyRole = 'Modification de rôles',
  DeleteRole = 'Suppresion de rôles',
  CreateService = 'Création de services',
  ModifyService = 'Modification de services',
  DeleteService = 'Suppression de services',
  ModifyEvents = 'Modification de l\'historique',
  AssignService = 'Assignation de service',
  RemoveService = 'Suppression de service',
  LdapService = 'Action dans l\'Active Directory',
  DataService = 'Action dans les référentiel',
  CreateExtra = 'Création d\'un compte extra',
  ModifyExtra = 'Modification d\'un compte extra',
  DeleteExtra = 'Suppression d\'un compte extra',
  CreateOrganisation = 'Création d\'une organisation',
  ModifyOrganisation = 'Modification d\'une organisation',
  DeleteOrganisation = 'Suppression d\'une organisation',
  ValidateOrganisation = 'Validation d\'une organisation',
  EnableStudent = 'Activation de comptes élève',
  DisableStudent = 'Désactivation de compte élève',
  GenerateActivationKey = 'Génération d\'une nouvelle clé d\'activation'

}

export default ActionTypes
